import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

const initialState = { isHandledPresetNameLoad: false, isHandledPresetTemplateLoad: false };

export const surveyCreation = createSlice({
  name: 'surveyCreation',
  initialState,
  reducers: {
    resetSurveyCreation: () => initialState,

    setSurveyCreationPresetLoadKey: (state, action) => {
      Object.keys(action.payload).forEach((key) => {
        state[key] = action.payload[key];
      });
    },
  },
});

export const { resetSurveyCreation, setSurveyCreationPresetLoadKey } = surveyCreation.actions;

export default surveyCreation.reducer;

// selectors
export const useSurveyCreationData = () => useSelector((state) => state.surveyCreation);

// to keep track if all preset value changes are handled, this is used to remove the preset query param once
// preset specific changes are done
export const useIsSurveyCreationAllPresetHandled = () => {
  const { isHandledPresetNameLoad, isHandledPresetTemplateLoad, isHandledFrequencyLoad } = useSelector(
    (state) => state.surveyCreation
  );

  return isHandledPresetNameLoad && isHandledPresetTemplateLoad && isHandledFrequencyLoad;
};
